
window.Notify = {

	message(level, text) {
        window.events.$emit('toast', {
            level: level,
            text: text
        });
	},

	success(text) {
		return this.message('success', text);
	},

	info(text) {
		return this.message('info', text);
	},

	warning(text) {
		return this.message('warning', text);
	},

	error(text) {
		return this.message('error', text);
	},

    swal(params) {
        return Swal.fire(params);
    }
};

module.exports = window.Notify;
